/** 官网会话：与账户中心共用同一 localStorage 记录。 */
export interface WebSession {
  accessToken: string
  refreshToken: string
  expiresAt: string
  user: { id: string; displayName: string; phoneMasked: string | null; membershipLevel: string | null }
}

const SESSION_KEY = 'nail-web.session.v1'

export const readWebSession = (): WebSession | null => {
  try {
    const raw = window.localStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) as WebSession : null
  } catch {
    return null
  }
}

export const clearWebSession = () => window.localStorage.removeItem(SESSION_KEY)
